import goldBottle from '@/assets/images/Mockup-Golden.png';
import silverBottle from '@/assets/images/Mockup-Silver.png';

/**
 * Catalog is built from the two real Ayat mockups (gold / silver), each product
 * placed on a distinct `tint` panel so the range reads as intentional. Swap the
 * `image` field per product when real photography arrives — nothing else changes.
 */

// Soft panel gradients behind each bottle. Kept here so cards/detail stay in sync.
export const tints = {
  cream: 'radial-gradient(120% 120% at 50% 15%, #ffffff 0%, #f3efe7 60%, #e9e2d5 100%)',
  sand: 'radial-gradient(120% 120% at 50% 15%, #fbf7ef 0%, #efe6d5 60%, #e2d4bd 100%)',
  rose: 'radial-gradient(120% 120% at 50% 15%, #fdf6f3 0%, #f3e4dd 60%, #e7d1c7 100%)',
  sage: 'radial-gradient(120% 120% at 50% 15%, #f6f7f2 0%, #e6ebe0 60%, #d6ddcd 100%)',
  smoke: 'radial-gradient(120% 120% at 50% 15%, #f7f6f4 0%, #e9e6e1 60%, #d8d3cc 100%)',
};

export const products = [
  {
    slug: 'never-ending',
    name: 'Never Ending',
    tagline: 'An impression that lingers',
    family: 'Amber',
    category: 'Unisex',
    concentration: 'Extrait de Parfum',
    price: 12500,
    compareAt: null,
    rating: 4.9,
    reviewsCount: 214,
    image: goldBottle,
    tint: 'sand',
    badges: ['bestseller'],
    shortNotes: 'Amber · Saffron · Sandalwood',
    notes: {
      top: ['Saffron', 'Bergamot'],
      heart: ['Amberwood', 'Jasmine'],
      base: ['Sandalwood', 'Vanilla', 'Musk'],
    },
    description:
      'The house signature. Never Ending opens on warm saffron and settles into a long amber drydown that seems to renew itself hour after hour — the trail you are remembered by.',
    ingredients:
      'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Linalool, Coumarin, Benzyl Salicylate.',
  },
  {
    slug: 'silent-verse',
    name: 'Silent Verse',
    tagline: 'A whisper you never forget',
    family: 'Amber',
    category: 'Unisex',
    concentration: 'Extrait de Parfum',
    price: 12500,
    compareAt: null,
    rating: 4.8,
    reviewsCount: 176,
    image: silverBottle,
    tint: 'smoke',
    badges: ['new'],
    shortNotes: 'Amber · Incense · Musk',
    notes: {
      top: ['Bergamot', 'Pink Pepper'],
      heart: ['Amber', 'Incense'],
      base: ['Musk', 'Cedar'],
    },
    description:
      'A hushed, smoky amber that speaks softly and stays close. Silent Verse settles into warm incense and musk — restrained, refined, quietly unforgettable.',
    ingredients:
      'Alcohol Denat., Parfum (Fragrance), Aqua (Water), Linalool, Coumarin, Benzyl Salicylate.',
  },
];

// --- Selectors -------------------------------------------------------------

export const getAllProducts = () => products;

export const getProductBySlug = (slug) => products.find((p) => p.slug === slug) ?? null;

export const getBestSellers = () => products.filter((p) => p.badges.includes('bestseller'));

export const getNewArrivals = () => products.filter((p) => p.badges.includes('new'));

export const getFeatured = () => products.slice(0, 4);

export const getRelated = (slug, count = 4) => {
  const current = getProductBySlug(slug);
  if (!current) return products.slice(0, count);
  const sameFamily = products.filter((p) => p.slug !== slug && p.family === current.family);
  const others = products.filter((p) => p.slug !== slug && p.family !== current.family);
  return [...sameFamily, ...others].slice(0, count);
};

export const families = ['All', 'Amber'];
